export const SET_CNPJS = "CNPJS/SET_CNPJS";
export const SET_CNPJ = "CNPJS/SET_CNPJ";
export const SET_PAGINATION = "CNPJS/SET_PAGINATION";
